"use client";

import React from "react";
import { Phone } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function AboutAcademy() {
  const {
    ref: leftColRef,
    isVisible: isLeftVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: rightColRef,
    isVisible: isRightVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="aboutacademy" className="py-20 md:py-24 bg-background text-foreground overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          
          {}
          <div ref={leftColRef} className={`flex flex-col gap-6 transition-all duration-1000 ease-out ${isLeftVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`}>
            <div className="flex items-center gap-2">
              <span className="w-2 h-2 rounded-full bg-primary"></span>
              <span className="text-sm font-semibold tracking-wider uppercase text-muted-foreground">
                Sobre Nosotros
              </span>
            </div>
            
            <h2 className="text-4xl md:text-5xl font-bold font-default leading-tight"></h2>
            
            <div className="space-y-4 text-lg text-muted-foreground border-l-4 border-primary pl-4 py-1">
              <p>En nuestra academia en Palencia ofrecemos una formación integral y personalizada para estudiantes de todas las edades y niveles. Somos un referente como Centro de Estudios en Palencia, comprometidos con la excelencia educativa y el acompañamiento continuo.</p>
              <p>Nuestro equipo de profesores garantizan un aprendizaje efectivo a través de metodologías adaptadas a cada alumno, con especial atención en las necesidades individuales.</p>
            </div>

            <div className="mt-4 flex items-center gap-4 bg-muted/50 p-4 rounded-lg w-fit">
              <div className="flex items-center justify-center w-12 h-12 rounded-full bg-primary text-primary-foreground shrink-0">
                <Phone className="w-6 h-6 text-secondary" />
              </div>
              <div>
                <p className="text-xs font-semibold uppercase tracking-wider text-muted-foreground mb-1">
                  ¡Llámanos!
                </p>
                <p className="text-xl font-bold font-default text-foreground">610 74 30 69</p>
              </div>
            </div>
          </div>

          {}
          <div ref={rightColRef} className={`relative h-[500px] md:h-[600px] transition-all duration-1000 delay-200 ease-out ${isRightVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`}>
            <div className="grid grid-cols-2 gap-4 h-full">
              <div className="col-span-1 h-full relative rounded-lg overflow-hidden shadow-md">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1658623/img/about_academy_students_studying.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1658623/img/about_academy_students_studying.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1658623/img/about_academy_students_studying.png-wvc-sizes" alt="Estudiantes estudiando en la academia" className="absolute inset-0 w-full h-full object-cover" loading="lazy" />
              </div>
              <div className="col-span-1 flex flex-col gap-4 h-full">
                <div className="relative h-1/2 rounded-lg overflow-hidden shadow-md">
                  <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1658623/img/about_academy_teacher_helping.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1658623/img/about_academy_teacher_helping.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1658623/img/about_academy_teacher_helping.png-wvc-sizes" alt="Profesor ayudando a un alumno" className="absolute inset-0 w-full h-full object-cover" loading="lazy" />
                </div>
                <div className="relative h-1/2 rounded-lg overflow-hidden shadow-md">
                  <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1658623/img/about_academy_student_writing.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1658623/img/about_academy_student_writing.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1658623/img/about_academy_student_writing.png-wvc-sizes" alt="Estudiante tomando notas" className="absolute inset-0 w-full h-full object-cover" loading="lazy" />
                </div>
              </div>
            </div>
            
            {}
            <div className="absolute -z-10 top-1/2 -right-12 w-64 h-64 bg-primary/10 rounded-full blur-3xl transform -translate-y-1/2"></div>
          </div>

        </div>
      </div>
    </section>;
}